import { ButtonLink } from '@/components/ui/button';
import { Compass } from 'lucide-react';
import { Page } from '@/components/layout/page';
import { Container, Section } from '@/components/ui/primitives';
import { paths } from '@/lib/paths';

/**
 * Page 404.
 *
 * Sur une application à page unique servie en statique, elle n'est atteinte
 * que si le serveur renvoie bien `index.html` pour toutes les routes inconnues
 * — c'est le rôle du `try_files … /index.html` de `nginx.conf`. Sans cette
 * règle, un rafraîchissement sur `/compte` renverrait un 404 du serveur web,
 * et React ne serait jamais chargé.
 */
export default function NotFoundPage() {
    return (
        <Page title="Page introuvable">
            <Section>
                <Container className="max-w-lg py-16 text-center">
                    <span className="bg-brand-50 text-brand-600 mx-auto flex size-16 items-center justify-center rounded-full">
                        <Compass className="size-8" aria-hidden />
                    </span>

                    <h1 className="font-display mt-6 text-4xl tracking-tight">Cette page n'existe pas</h1>

                    <p className="text-ink-soft mt-3 leading-relaxed">
                        Le lien est peut-être obsolète, ou l'adresse comporte une coquille. Reprenons depuis la
                        recherche.
                    </p>

                    <div className="mt-8 flex flex-wrap justify-center gap-3">
                        <ButtonLink to={paths.search}>Rechercher une entreprise</ButtonLink>
                        <ButtonLink to={paths.home} variant="secondary">
                            Retour à l'accueil
                        </ButtonLink>
                    </div>
                </Container>
            </Section>
        </Page>
    );
}
